import DealsCarousel from './DealsCarousel';
import ProductsCarousel from "./ProductsCarousel";
import OrderCarousel from "./OrderCarousel";

export default {
  DealsCarousel,
  OrderCarousel,
  ProductsCarousel,
};
